import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Question = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="question icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.25 7.25C9.25 5.73122 10.4812 4.5 12 4.5C13.5188 4.5 14.75 5.73122 14.75 7.25C14.75 7.95758 14.33 8.75929 13.4658 9.3561C12.577 9.9699 11.5989 10.8121 10.864 11.861C10.125 12.9156 9.52605 14.3423 9.76179 15.9925L9.76179 15.9925L9.77261 16.0682C9.94834 17.2983 11.088 18.1531 12.3182 17.9774C13.5483 17.8017 14.4031 16.662 14.2274 15.4318L14.2166 15.3561L14.2166 15.3561C14.1941 15.199 14.2216 14.911 14.5493 14.4433C14.8809 13.9701 15.4095 13.4826 16.023 13.0589C17.8071 11.8268 19.25 9.7633 19.25 7.25C19.25 3.24594 16.0041 0 12 0C7.99594 0 4.75 3.24594 4.75 7.25C4.75 8.49264 5.75736 9.5 7 9.5C8.24264 9.5 9.25 8.49264 9.25 7.25ZM14.5 21.5C14.5 22.8807 13.3807 24 12 24C10.6193 24 9.5 22.8807 9.5 21.5C9.5 20.1193 10.6193 19 12 19C13.3807 19 14.5 20.1193 14.5 21.5Z"
    />
  </svg>
)
